module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Composite_Steel_&_Concrete_Bridge_-_Multi-Girder_60m.Steel.20414239.png";